import React from 'react';
import { Link } from 'react-router-dom';
import { Info, Briefcase, FolderOpen, Mail } from 'lucide-react';

const AdminDashboard = () => {
  const cards = [
    {
      title: 'Hakkımızda',
      description: 'Şirket bilgilerini ve görselleri düzenleyin',
      icon: Info,
      link: '/admin/about',
      color: '#2C74B3'
    },
    {
      title: 'Hizmetler',
      description: 'Hizmet ekleyin, düzenleyin veya silin',
      icon: Briefcase,
      link: '/admin/services',
      color: '#0A2647'
    },
    {
      title: 'Projeler',
      description: 'Proje referanslarını yönetin',
      icon: FolderOpen,
      link: '/admin/projects',
      color: '#144272'
    },
    {
      title: 'İletişim',
      description: 'İletişim bilgilerini güncelleyin',
      icon: Mail,
      link: '/admin/contact',
      color: '#205295'
    }
  ];

  return (
    <div className="admin-dashboard">
      <h1 className="admin-page-title">Admin Dashboard</h1>
      <p className="admin-page-subtitle">EDGE MARINE web sitesi içerik yönetimi</p>

      <div className="admin-dashboard-grid">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <Link
              key={card.link}
              to={card.link}
              className="admin-dashboard-card"
              style={{ '--card-color': card.color }}
            >
              <div className="admin-dashboard-card-icon" style={{ background: card.color }}>
                <Icon size={32} color="white" />
              </div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </Link>
          );
        })}
      </div>

      <div className="admin-info-box">
        <h3>Hoş Geldiniz!</h3>
        <p>Bu admin panelden web sitenizdeki tüm içerikleri yönetebilirsiniz:</p>
        <ul>
          <li>Görselleri değiştirin ve yükleyin</li>
          <li>Metinleri düzenleyin</li>
          <li>Yeni hizmetler ve projeler ekleyin</li>
          <li>İçerikleri silin veya güncelleyin</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;
